import { render } from "./IconLeaderBoard.vue?vue&type=template&id=66f06651"
import script from "./IconLeaderBoard.vue?vue&type=script&lang=js"
export * from "./IconLeaderBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__